import React from 'react';
import T from 'prop-types';

import useEffectOnce from '../../hooks/useEffectOnce';

interface RequestFavoritesDataProps {
  getFavorites: () => void;
}

const RequestFavoritesData: React.FC<RequestFavoritesDataProps> = ({ getFavorites }) => {
  useEffectOnce(() => {
    getFavorites();
  });

  return null;
};

RequestFavoritesData.propTypes = {
  getFavorites: T.func.isRequired,
};

export default RequestFavoritesData;
